"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const plugins_1 = require("./plugins");
// import * as _ from 'lodash';
const Cesium = window.Cesium;
class LiveDataController extends plugins_1.FdmPlugin {
    constructor() {
        super(...arguments);
        // our controls
        this.controls = {
            info: { type: 'info', value: '', translateValue: true, translateExtra: false },
            distance: { type: 'check', value: true },
        };
        // the tracked entities
        this.originalEntities = [];
        // default pulse mode
        this.pulseSeconds = 1;
    }
    objectInjected() {
        if (this.object && this.object.entities) {
            this.originalEntities = this.object.entities.values;
        }
        else {
            this.originalEntities = [this.object];
        }
        this.startPulse();
    }
    end() {
        this.stopPulse();
    }
    pulse() {
        this.controls.info.value = 'PLUGINS.DYNAMIC_PROPERTY_CONTROLLER.NO_TRACKING';
        // if we're tracking distance to camera
        if (this.controls.distance.value) {
            const camdist = this.services.mapService.viewer.camera.position;
            this.originalEntities.forEach(ee => {
                if (ee) {
                    this.services.coordHelper.getCoordFromCesiumObject(ee).then(coord => {
                        if (coord) {
                            this.setTypeValue(ee, 'distanceToCamera', Math.floor(Cesium.Cartesian3.distance(coord, camdist)));
                            // console.log('##EE', coord, this.getTypeValue ( ee, 'distanceToCamera' ) );
                        }
                        else {
                            // console.log('##EE error', coord, ee );
                        }
                    });
                }
            });
            this.controls.info.value = 'PLUGINS.DYNAMIC_PROPERTY_CONTROLLER.TRACKING';
            this.controls.info.extra = this.originalEntities.length;
            // console.log('!!trackedCameraDistance', this.originalEntities.length );
        }
    }
    getTypeValue(ee, type = 'dunno') {
        if (ee && ee['__live_data']) {
            return ee['__live_data'][type];
        }
        return null;
    }
    setTypeValue(ee, type = 'dunno', value = null) {
        if (!ee) {
            return null;
        }
        if (!ee['__live_data']) {
            ee['__live_data'] = {};
        }
        ee['__live_data'][type] = value;
    }
    // may not be needed, but ...
    refresh(newvalue = null, section = null) {
        // check in with mama
        super.refresh(newvalue, section);
        /*
                if ( this.controls.dataFeed.value ) {
                    this.turnOn(['dataFeedURL','dataFeedPulse']);
                } else {
                    this.turnOff(['dataFeedURL','dataFeedPulse']);
        
                }
        */
    }
}
// required name identifier
LiveDataController.meta = {
    label: 'PLUGINS.DYNAMIC_PROPERTY_CONTROLLER.LABEL',
    name: 'live-data-controller',
    translator: 'PLUGINS.DYNAMIC_PROPERTY_CONTROLLER',
    tooltip: 'PLUGINS.DYNAMIC_PROPERTY_CONTROLLER.TOOLTIP',
    shortcut: false,
    icon: 'satellite-dish',
    types: [
        plugins_1.FdmPlugin.types.transformController,
        plugins_1.FdmPlugin.types.entityController
    ],
    category: plugins_1.FdmPlugin.category.advanced,
    cardinality: plugins_1.FdmPlugin.cardinality.one
};
exports.LiveDataController = LiveDataController;
